import { makeAutoObservable } from "mobx";
import { IdentifiableMap, RMutableMap, } from "../../collections";
import { Quantity } from "../../core";
import { ModifierInstance } from "../ProductInstance";
export class ModifierInstanceCreator {
    constructor(params) {
        this.behaviour = params.behaviour;
        this.editorHidden = params.editorHidden;
        if (params.modifierType.behaviour !== this.behaviour) {
            throw new Error("Modifier behaviour mismatch");
        }
        this.modifierType = params.modifierType;
        this.modifierSettings = params.modifierSettings;
        this.itemQuantities = params.itemQuantities;
        this.itemCreators = params.itemCreators;
        this.editability = params.editability;
        makeAutoObservable(this);
    }
    get typeId() {
        return this.modifierType.id;
    }
    /** Item entries, only items which are selected */
    get selectedItems() {
        return this.itemCreators.filter((itemInstance) => itemInstance.isSelected);
    }
    get modifierInstance() {
        const items = IdentifiableMap.fromIterable("typeId", this.itemCreators.objects.map((modifierItemInstanceCreator) => modifierItemInstanceCreator.modifierItemInstance));
        return new ModifierInstance({
            modifierType: this.modifierType,
            modifierSettings: this.modifierSettings,
            items,
        });
    }
    selectInferredDefaults() {
        if (this.selectedItems.isEmpty && this.modifierType.minItems.isOne) {
            const availableItems = this.itemCreators.filter((itemInstanceCreator) => itemInstanceCreator.isEditable);
            if (availableItems.size === 1) {
                availableItems.sample.select();
            }
        }
    }
    setSelectedItemIds(selectedItemTypeIds) {
        var _a;
        const counts = RMutableMap.empty({
            makeAutoObservable: false,
        });
        for (const itemId of selectedItemTypeIds) {
            const count = counts.getOrCreate(itemId, () => Quantity.Zero);
            counts.update(itemId, count.incremented());
        }
        for (const itemInstanceCreator of this.itemCreators.objects) {
            const count = (_a = counts.find(itemInstanceCreator.typeId)) !== null && _a !== void 0 ? _a : Quantity.Zero;
            this.itemQuantities.setQuantity(itemInstanceCreator.typeId, count);
        }
    }
}
